export const API_BASE_URL =
    (process.env.REACT_APP_API_BASE_URL ?? '')
        .replace(/\/+$/, '');

export const AUTH_TOKEN_STORAGE_KEY = 'auth.jwt';
export const AUTH_SESSION_STORAGE_KEY = 'auth.session';
